import { useState } from 'react';

const STORAGE_PREFIX = 'sidebar.chats.group.';

/** Reads a group's persisted fold state; defaults to expanded when unset or storage throws. */
function readStored(key: string): boolean {
  try {
    const raw = window.localStorage.getItem(`${STORAGE_PREFIX}${key}`);
    return raw === null ? true : raw === 'expanded';
  } catch {
    return true;
  }
}

/**
 * Whether one sidebar chat group is expanded, persisted to localStorage under
 * `sidebar.chats.group.<key>` so a fold survives a reload. A write that throws
 * (private browsing, a blocked origin) still toggles the group for this session.
 */
export function useChatGroupFold(key: string) {
  const [expanded, setExpanded] = useState(() => readStored(key));

  const toggle = () => {
    setExpanded(previous => {
      const next = !previous;
      try {
        window.localStorage.setItem(`${STORAGE_PREFIX}${key}`, next ? 'expanded' : 'collapsed');
      } catch {
        /* no-op: best-effort persistence, already documented above */
      }
      return next;
    });
  };

  return { expanded, toggle };
}
